export default __webpack_public_path__ + "media/images/manual/ic/14-4dd888914a84bbd6c67ef7a102ffa195.png";